import { ref } from 'vue'
import { apiPost } from '@/composables/useApi'
import { getDemoTranslatedSubtitles } from '@/assets/demo/translations'

export function useSubtitleTranslation() {
  const isTranslated = ref(false)
  const targetLanguage = ref('zh')
  const translatedSubtitles = ref(null)
  const isTranslating = ref(false)

  async function requestTranslation({ audioId, materialId, materialBook, lang, splitType, isMaterialFile }) {
    const data = await apiPost('/api/translate', {
      file_id: audioId,
      material_id: isMaterialFile ? materialId : null,
      material_book: isMaterialFile ? materialBook : null,
      target_language: lang,
      split_type: splitType
    })

    if (data.success === true && data.translatedSubtitles?.length) {
      return data.translatedSubtitles
    }

    throw new Error(data.error || 'Translation result is empty')
  }

  async function handleTranslateLanguage(lang, {
    audioId,
    materialId,
    materialBook,
    splitType,
    isDemo,
    demoTranslations,
    demoSourceSubtitles,
  }) {
    if (lang === 'none') {
      isTranslated.value = false
      isTranslating.value = false
      targetLanguage.value = ''
      translatedSubtitles.value = null
      return { success: true }
    }
    if (isTranslating.value) return { success: false, error: new Error('Translation already running') }

    isTranslating.value = true
    try {
      isTranslated.value = true
      targetLanguage.value = lang

      if (isDemo) {
        let demoTranslation = null
        if (demoTranslations && Array.isArray(demoSourceSubtitles)) {
          const translationSet = demoTranslations[lang]
          const translatedTexts = lang === 'en'
            ? demoSourceSubtitles.map((subtitle) => subtitle.text)
            : (Array.isArray(translationSet)
                ? translationSet
                : translationSet?.[splitType] || translationSet?.practice)
          if (translatedTexts?.length === demoSourceSubtitles.length) {
            demoTranslation = demoSourceSubtitles.map((subtitle, index) => ({
              ...subtitle,
              text: translatedTexts[index],
            }))
          }
        } else {
          demoTranslation = getDemoTranslatedSubtitles({ lang, splitType })
        }
        if (!demoTranslation?.length) throw new Error('Demo translation not found')
        translatedSubtitles.value = demoTranslation
        return { success: true }
      }

      const isMaterialFile = audioId?.startsWith('materials-')
      translatedSubtitles.value = await requestTranslation({
        audioId,
        materialId,
        materialBook,
        lang,
        splitType,
        isMaterialFile
      })
      return { success: true }
    } catch (error) {
      isTranslated.value = false
      translatedSubtitles.value = null
      return { success: false, error }
    } finally {
      isTranslating.value = false
    }
  }

  return {
    isTranslated,
    targetLanguage,
    translatedSubtitles,
    isTranslating,
    handleTranslateLanguage
  }
}
